import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import useResponsive from '../../../../../../hooks/use-responsive';
import { toArray } from '../../../../../../services/components';
import Pagination from '../../../Pagination';
import { displayCarouselIndicators, getAutoScrollInterval, getElementKey, showIndicators } from '../../services';
import { canSafelyServerRender, getStepSize } from '../../services/carousel';
import { INDICATORS_POSITION } from '../../services/constants';
import { BaseCarouselPropTypes, BaseCarouselDefaultProps } from '../../types/base';
import './StackSliderCarousel.css';
var defaultProps = _objectSpread(_objectSpread({}, BaseCarouselDefaultProps), {}, {
  displayIndicators: false,
  renderItemContainer: function renderItemContainer(item) {
    return /*#__PURE__*/React.createElement(Grid.Row, {
      className: "pagination-element"
    }, /*#__PURE__*/React.createElement(Grid.Column, {
      key: getElementKey(item)
    }, item));
  }
});
export default function StackSliderCarousel(_ref) {
  var items = _ref.items,
    size = _ref.size,
    stepSize = _ref.stepSize,
    grouping = _ref.grouping,
    autoScroll = _ref.autoScroll,
    continuous = _ref.continuous,
    displayIndicators = _ref.displayIndicators,
    indicatorsPosition = _ref.indicatorsPosition,
    pageIndicatorIcon = _ref.pageIndicatorIcon,
    className = _ref.className,
    renderItemContainer = _ref.renderItemContainer,
    invertedDirection = _ref.invertedDirection,
    animation = _ref.animation,
    displayLeftRightArrows = _ref.displayLeftRightArrows;
  if (_isEmpty(items)) {
    return null;
  }
  var responsiveDevice = useResponsive();
  var isMobile = responsiveDevice.isMobile,
    loaded = responsiveDevice.loaded;
  var pageSize = size;
  var displayControls = displayIndicators ? displayCarouselIndicators(pageSize, items, {
    isMobile: isMobile
  }) : false;
  var finalStepSize = getStepSize(items, pageSize, stepSize, grouping);
  var autoScrollInterval = getAutoScrollInterval(autoScroll, {
    pageSize: pageSize,
    items: items
  });
  var canServerRender = canSafelyServerRender(items, size, false, {});
  var leftArrow = /*#__PURE__*/React.createElement(Grid.Row, {
    className: "arrow left-arrow"
  }, /*#__PURE__*/React.createElement(Pagination.Arrow, {
    direction: invertedDirection ? 'next' : 'previous',
    icon: "chevron up"
  }));
  var rightArrow = /*#__PURE__*/React.createElement(Grid.Row, {
    className: "arrow right-arrow"
  }, /*#__PURE__*/React.createElement(Pagination.Arrow, {
    direction: invertedDirection ? 'previous' : 'next',
    icon: "chevron down"
  }));
  var controls = /*#__PURE__*/React.createElement(Grid.Row, {
    className: "controls"
  }, /*#__PURE__*/React.createElement(Pagination.Indicators, {
    compact: true,
    fitted: true,
    borderless: true,
    vertical: false,
    onlyPageIndicators: true,
    pageIndicatorIcon: pageIndicatorIcon,
    show: showIndicators(pageSize, items, {
      threshold: 6
    })
  }));
  var carousel = /*#__PURE__*/React.createElement(Pagination.Elements, null, function (activeItems) {
    if (!loaded && !canServerRender) {
      return null;
    }
    return activeItems.map(renderItemContainer);
  });
  var content = [carousel];
  if (displayLeftRightArrows) {
    content = [leftArrow, carousel, rightArrow];
  }
  if (displayControls) {
    content = indicatorsPosition === INDICATORS_POSITION.top ? [controls].concat(_toConsumableArray(content)) : [].concat(_toConsumableArray(content), [controls]);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "carousel stack-slider-carousel ".concat(className)
  }, /*#__PURE__*/React.createElement(Pagination, {
    pageSize: pageSize,
    items: toArray(items),
    carousel: true,
    stepSize: finalStepSize,
    grouping: grouping,
    continuous: continuous,
    autoScroll: !!autoScroll,
    autoScrollInterval: autoScrollInterval,
    animation: animation
  }, /*#__PURE__*/React.createElement(Grid, null, content)));
}
StackSliderCarousel.defaultProps = defaultProps;